export const SET_CREATE_IS_VISIBLE = 'SET_CREATE_IS_VISIBLE';
export const CREATE_PROJECT = 'CREATE_PROJECT';
export const CREATE_PROJECT_ERROR = 'CREATE_PROJECT_ERROR';



// WEBPACK FOOTER //
// ./src/containers/NewProject/constants.js